export class ckEditorBroadcastMessage {
    userName: string;
    userId: string;
    selfAssessmentId: number;
    loggedInUsers:string;
    url:string;
    constructor(){
     this.selfAssessmentId=0;
     this.userId="";
     this.userName="";
     this.loggedInUsers="";
     this.url="";
    }
  }
  export interface LoggedUserItem {
    userId: string;
    userName: string;
  }